/* eslint-disable no-use-before-define */
// Frequency Spectrum Visualisation Module
//
// Draws a live audio FFT horizontaly

// TODO:
// [] Add ability to reduce the bins drawn (divider?)
// [] Add a switch to display linear/exponential FFT
// [] Add smoothing option
// [] Add identification of signal spikes

import { remap } from '../utils.js';
export {
    setup, draw
}

let offscreen;
let ctx;
let width;
let height;
let divider;

// Module-global variables pulled out of their functions for better memory managment
let i; // Used in draw()
let x; let h; // Used in draw()

// Default options
const options = {
  background: 'transparent',
  color: '#ff8800',        // Spectrum color
  fftBins: 1024,           // 0 - 1024 in n^2 steps
  noiseFloor: -140,        // dB, (max -140 dB)
  lowerFreq: 0,            // Hz, Lower frequency at which views will draw
  upperFreq: 20000,        // Hz, Upper frequency at which views will draw
  gateThreshold: -50,      // dB, The level at which we consider having a signal
  detectionLineWidth: 2,
};

function setup({ cellWidth, cellHeight, devicePixelRatio }) {
  // Save these dimensions as module-scoped variables
  width = cellWidth * devicePixelRatio;
  height = cellHeight * devicePixelRatio;

  // Create an offscreen graphics buffer to draw in
  offscreen = new OffscreenCanvas(width, height);
  ctx = offscreen.getContext('2d');

  // Fill in the background with a solid color
  ctx.fillStyle = options.background;
  ctx.clearRect(0, 0, width, height);

  // Set up some constants
  divider = 24000 / options.upperFreq;
}

function draw(spectrumData) {
  if (spectrumData) {
    // Erase the graphics buffer with background color
    ctx.fillStyle = options.background;
    ctx.clearRect(0, 0, width, height);

    // Set FFT style
    ctx.fillStyle = options.color;

    // Draw FFT
    for (i = 0; i < spectrumData.length / divider; i++) {
      x = remap(i, 0, options.fftBins / divider, 0, width);
      h = -height + remap(
        spectrumData[i],
        options.noiseFloor, 0,
        height, 0,
        true
      );
      ctx.fillRect(x, height, (width / spectrumData.length) * divider, h);
    }
  }

  return offscreen.transferToImageBitmap();
}
